import React, {Dispatch, SetStateAction} from 'react';
import * as SelectRadix from '@radix-ui/react-select';
import classnames from 'classnames';
import {AiOutlineCheckCircle} from 'react-icons/ai';
import {BiSolidDownArrow, BiSolidUpArrow} from 'react-icons/bi';
import styles from "./SelectWithValues.module.css";

// 1. Defina os tipos para as props
interface SelectProps {
  selectTexts: string[];
  selectValues: string[];
  selectedValue: string;
  setSelectedValue: Dispatch<SetStateAction<any>>;
}

const Select: React.FC<SelectProps> = ({ selectedValue, setSelectedValue, selectTexts, selectValues }) => {
  return (
    <SelectRadix.Root onValueChange={value => setSelectedValue(value)}>
      <SelectRadix.Trigger className={styles.SelectTrigger} aria-label="Food">
        <SelectRadix.Value defaultValue={selectedValue} placeholder="Relevantes" />
        <SelectRadix.Icon className={styles.SelectIcon}>
          <BiSolidDownArrow />
        </SelectRadix.Icon>
      </SelectRadix.Trigger>
      <SelectRadix.Portal>
        <SelectRadix.Content className={styles.SelectContent}>
          <SelectRadix.ScrollUpButton className={styles.SelectScrollButton}>
            <BiSolidUpArrow />
          </SelectRadix.ScrollUpButton>
          <SelectRadix.Viewport className={styles.SelectViewport}>
            <SelectRadix.Group>
              <SelectRadix.Label className={styles.SelectLabel}>Escolha</SelectRadix.Label>
              <SelectRadix.Separator className={styles.SelectSeparator} />
              {
                selectTexts.map((text, index) => {
                  return <SelectItem key={index} value={selectValues[index]}>{text}</SelectItem>
                })
              }
            </SelectRadix.Group>
          </SelectRadix.Viewport>
          <SelectRadix.ScrollDownButton className={styles.SelectScrollButton}>
            <BiSolidDownArrow />
          </SelectRadix.ScrollDownButton>
        </SelectRadix.Content>
      </SelectRadix.Portal>
    </SelectRadix.Root>
  );
};

// 3. Ajuste o componente SelectItem para aceitar os tipos corretos
interface SelectItemProps {
  children: React.ReactNode;
  className?: string;
  value: string;
}

const SelectItem = React.forwardRef<HTMLDivElement, SelectItemProps>(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <SelectRadix.Item className={classnames(styles.SelectItem, className)} {...props} ref={forwardedRef}>
        <SelectRadix.ItemText>{children}</SelectRadix.ItemText>
        <SelectRadix.ItemIndicator className={styles.SelectItemIndicator}>
          <AiOutlineCheckCircle size={22}/>
        </SelectRadix.ItemIndicator>
      </SelectRadix.Item>
    );
  }
);

export default Select;
